import useWidgetActionsBuilder from "./useWidgetActionsBuilder";

const useActionsBuilder = (actions, additionalOptions = {}) => {
  const defaultConfigBuilder = () => { return {} };
  return useWidgetActionsBuilder(actions, defaultConfigBuilder, additionalOptions);
};

export default useActionsBuilder;